var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{attrs:{"value":_vm.selectedDate,"compact":true,"hide-details":true},on:{"input":_vm.dateChanged,"error-changed":_vm.onError}})}
var staticRenderFns = []

export { render, staticRenderFns }